import { ReferenceManyField, Tab, TabProps, TextField } from 'react-admin';
import { TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { MainDatagridStyled } from '@/styles/overrides';
import LicenseField from './LicenseField';

const MvrLicenseTab = (props: Partial<TabProps>) => {
  return (
    <Tab label="Licenses" {...props}>
      <ReferenceManyField label="" reference={TurnReferencesEnum.Candidates} target={TurnTargetsEnum.WorkerMvrLicense}>
        <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
          <TextField source="id" />
          <LicenseField label="License Number" />
        </MainDatagridStyled>
      </ReferenceManyField>
    </Tab>
  );
};

export default MvrLicenseTab;
